import React from 'react';
import '../css/Collab.css';

const ProductCard = ({
  productImage,
  productTitle,
  isVegan = false,
  isGlutenFree = false,
  veganIcon,
  glutenFreeIcon,
  retailPrice,
  retailUnit,
  wholesalePrice,
  wholesaleUnit,
  description,
  extraInfo,
  hidden = false,
}) => {
  return (
    <div className={`product-card ${hidden ? 'is-hidden' : ''}`}>
      <div className="product-image">
        <img src={productImage} alt={productTitle} />
      </div>

      <div className="product-info">
        <div className="product-title">
          <h3>{productTitle}</h3>
          {isVegan && veganIcon && (
            <img src={veganIcon} alt="Vegan" className="vegan-icon" />
          )}
          {isGlutenFree && glutenFreeIcon && (
            <img src={glutenFreeIcon} alt="Gluten Free" className="vegan-icon" />
          )}
        </div>

        <span className="product-price">Retail: <strong>{retailPrice}</strong> {retailUnit}</span>
        <span className="product-price">Wholesale: <strong>{wholesalePrice}</strong> {wholesaleUnit}</span>
        {description && (
          <p>{description}</p>
        )}
        {extraInfo && (
          <span className="product-extra-info">{extraInfo}</span>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
